import createIcon from '../../createIcon';

/**
 * @component @name Margin
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyAzVjIxSDIxVjNIM1pNMTkgMTlINVY1SDE5VjE5Wk0xMSA3SDEzVjlIMTFWN1pNNyA3SDlWOUg3VjdaTTE1IDdIMTdWOUgxNVY3Wk03IDExSDlWMTNIN1YxMVpNMTEgMTFIMTNWMTNIMTFWMTFaTTE1IDExSDE3VjEzSDE1VjExWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Margin = createIcon('Margin', [
  [
    'path',
    {
      d: 'M3 3V21H21V3H3ZM19 19H5V5H19V19ZM11 7H13V9H11V7ZM7 7H9V9H7V7ZM15 7H17V9H15V7ZM7 11H9V13H7V11ZM11 11H13V13H11V11ZM15 11H17V13H15V11Z',
      key: '19joth',
    },
  ],
]);

export default Margin;
